import React from 'react';
import HistoryIcon from '@material-ui/icons/LocalLibrary';
import DramaIcon from '@material-ui/icons/Theaters';
import ConcertIcon from '@material-ui/icons/MusicVideo';
import WordsIcon from '@material-ui/icons/Subject';
import HotPointsIcon from '@material-ui/icons/ImageSearch';
import WordGamesIcon from '@material-ui/icons/ViewModule';
import HowItWorksIcon from '@material-ui/icons/ContactSupport';
import DialoguesIcon from '@material-ui/icons/RecordVoiceOver';
import DiyIcon from '@material-ui/icons/Dvr';
import TheWordsIcon from '@material-ui/icons/VerticalSplit';
import JeopardyIcon from '@material-ui/icons/LocalPlay';
import SayIcon from '@material-ui/icons/Mic';
import EvalIcon from '@material-ui/icons/TouchApp';
// import GamesIcon from '@material-ui/icons/Games';
import GrammarIcon from '@material-ui/icons/FontDownload';
import FileIcon from '@material-ui/icons/LibraryBooks';
import MostUsefulIcon from '@material-ui/icons/AccountBalanceWallet';
import LearnByHeartIcon from '@material-ui/icons/AssignmentTurnedIn';
import MatchItIcon from '@material-ui/icons/Widgets';
import OrderThemIcon from '@material-ui/icons/ViewList';
import WordNetworkIcon from '@material-ui/icons/DeviceHub';
import OppositiesIcon from '@material-ui/icons/SwapHorizontalCircle';
import TalkToMeIcon from '@material-ui/icons/ChatBubble';
import AtHomeIcon from '@material-ui/icons/Home';
import ReadUnderstandIcon from '@material-ui/icons/LocalLibrary';
import CardsIcon from '@material-ui/icons/CardMembership';
import ListenUnderstandIcon from '@material-ui/icons/Hearing';
import PlayItIcon from '@material-ui/icons/Theaters';
import PairsIcon from '@material-ui/icons/People';
import VisualizeIcon from '@material-ui/icons/Image';
import QuizIcon from '@material-ui/icons/ContactSupport';
import CuriositiesIcon from '@material-ui/icons/EmojiObjects';
import TheOtherIcon from '@material-ui/icons/SentimentVeryDissatisfied';

import { 
  HISTORY, DRAMA, CONCERT, WORDS, HOT_POINTS, WORD_GAME, DIALOGUES, HOW_LANG_WORKS, SAY, GRAMMAR, FILE, EVALUATION, DIY,
  THE_WORDS, JEOPARDY, MOST_USEFUL, LEARN_BY_HEART, MATCH_IT, ORDER_THEM, WORD_NETWORK, OPPOSITES, TALK_TO_ME, AT_HOME,
  READ_UNDERSTAND, CARDS, LISTEN_UNDERSTAND, PLAY_IT, PAIRS, VISUALIZE, QUIZ, CURIOSITIES, THE_OTHER,       
} from '../../redux/types';


export default ({ type }) => {
  switch(type) {
    case DRAMA:
      return <DramaIcon />
    case CONCERT:
      return <ConcertIcon />
    case HISTORY:
      return <HistoryIcon />
    case WORDS:
      return <WordsIcon />
    case HOT_POINTS:
      return <HotPointsIcon />
    case WORD_GAME:
      return <WordGamesIcon />
    case HOW_LANG_WORKS:
      return <HowItWorksIcon />
    case DIALOGUES:
      return <DialoguesIcon />
    case SAY:
      return <SayIcon />
    case GRAMMAR:
      return <GrammarIcon />
    case FILE:
      return <FileIcon />
    case EVALUATION:
      return <EvalIcon />
    case DIY:
      return <DiyIcon />
    case THE_WORDS:
      return <TheWordsIcon />
    case JEOPARDY:
      return <JeopardyIcon />  
    case MOST_USEFUL:
      return <MostUsefulIcon />
    case LEARN_BY_HEART:
      return <LearnByHeartIcon />
    case MATCH_IT:
      return <MatchItIcon />
    case ORDER_THEM:
      return <OrderThemIcon />
    case WORD_NETWORK:
      return <WordNetworkIcon />
    case OPPOSITES:
      return <OppositiesIcon />
    case TALK_TO_ME:
      return <TalkToMeIcon />
    case AT_HOME:
      return <AtHomeIcon />
    case READ_UNDERSTAND:
      return <ReadUnderstandIcon />
    case CARDS:
      return <CardsIcon />
    case LISTEN_UNDERSTAND:
      return <ListenUnderstandIcon />
    case PLAY_IT:
      return <PlayItIcon />
    case PAIRS:
      return <PairsIcon />
    case VISUALIZE:
      return <VisualizeIcon />
    case QUIZ:
      return <QuizIcon />
    case CURIOSITIES:
      return <CuriositiesIcon />
    case THE_OTHER:
      return <TheOtherIcon />
    default:
      return '';
  }
}

